import { Breakpoints } from '../breakpoints/breakpoints';
import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        root: '.navigation-link-groups',
        linkGroupHeadline: '.navigation-link-groups__group-headline',
    },
    classNames: {
        linkGroupHeadlineActive: 'navigation-link-groups__group-headline--active',
    },
};

// this element is accordion, but we use a headline|content|headline|content markup because its a grid
// we use .next() to determine the right content to toggle
class NavigationLinkGroups {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = null;

    }

    init() {
        this._elements = this._getDomElements();
        this._addEventListeners();

        if (!Breakpoints.isBreakpoint('md') ||  !Breakpoints.isBreakpoint('mdlg')) {
            this._elements.$linkGroupHeadline.each((index, el) => {
                this._setActive($(el));
            });
        }

        this._addGridClasses();
    }

    _getDomElements() {
        return {
            $linkGroupHeadline: this._$rootElement.find(config.selectors.linkGroupHeadline),
        };
    }
  
    _setActive($headline) {
        const $content = $headline.next();

        if(Breakpoints.isBreakpoint('xs') || Breakpoints.isBreakpoint('sm') ){

            if ($content.height() !== 0) {
                $content.css('height', 0);
                $headline.removeClass(config.classNames.linkGroupHeadlineActive);
    
            } else {
                $content.css('height', `${$content[0].scrollHeight }px`);
                $headline.addClass(config.classNames.linkGroupHeadlineActive);
            }
        }
        
    }

    _addEventListeners() {
        const _this = this;
        this._elements.$linkGroupHeadline.on('click', function (e) {
            _this._setActive($(this));
        });

        window.addEventListener('resize', () => {
            if (!Breakpoints.isBreakpoint('md') ||  !Breakpoints.isBreakpoint('mdlg')) {
                this._elements.$linkGroupHeadline.each((index, el) => {
                    this._setActive($(el));
                });
            }
        });
    }

    _addGridClasses() {
        const childCount = this._$rootElement.children().length / 2;
        // console.log('childCount', childCount);
        this._$rootElement.addClass('navigation-link-groups--' + childCount);

        let j = 1;

        this._$rootElement.children().each((i,child) => {
            const $child = $(child);

            // console.log('current', $child);
            
            if($child.hasClass('navigation-link-groups__group-headline')) {
                $child.addClass('navigation-link-groups__group-headline--' + j);
            } else {
                $child.addClass('navigation-link-groups__group-content--' + j);
            }

            if(i !== 0 && i % 2 !== 0) {
                j++;
            }
        });

    }
}

moduleRegistry.registerModule('NavigationLinkGroups', NavigationLinkGroups);
moduleRegistry.autoApplyModule('NavigationLinkGroups', config.selectors.root);
